import React, { useContext } from "react";
import { Modal, Table, Row } from "react-bootstrap";
import { CancelButton } from "../../common/Button";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";

const ProductVariantModal = ({ show, handleClose, data, product }) => {
  console.log(data, "datadata");

  const {
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
    postData,
  } = useContext(Context);

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Variant Details - {product}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>Type Name</th>
              <th>Sub Type Name</th>
              <th>Length</th>
              <th>Width</th>
              <th>Square Foot</th>
              <th>Single Qty Price</th>
              <th>Multiple Qty Price</th>
            </tr>
          </thead>

          <tbody>
            {data?.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>

                <td>{item?.Type?.name || "-"}</td>

                <td>{item?.Sub_Type?.name || "-"}</td>

                <td>{item?.length || "-"}</td>

                <td>{item?.width || "-"}</td>

                <td>{item?.square_foot || "-"}</td>

                <td>{item?.single_quantity_price || "-"}</td>

                <td>{item?.multiple_quantity_price || "-"}</td>
              </tr>
            ))}
          </tbody>
        </Table>

        <Row className="mt-4">
          <div className="d-flex justify-content-center">
            <Link>
              <CancelButton name={"Close"} handleClose={handleClose} />
            </Link>
          </div>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default ProductVariantModal;
